import { AbstractControl, ValidatorFn } from '@angular/forms';
import { CancellationReasonEnum } from '@rma/billing-api';

export const feedbackValidator: ValidatorFn = (control: AbstractControl) => {
  const reason = control.get('cancellationReason')?.value;
  const feedback = control.get('cancellationFeedback')?.value;

  return reason === CancellationReasonEnum.Other && (!feedback || feedback.trim().length === 0) ? { feedbackRequired: true } : null;
};
